import React from 'react';
import { Card, Col, Row } from "antd";
import { Link } from 'react-router-dom';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import './grid.css'
import { useDispatch, useSelector } from 'react-redux';
import { getAttachment } from 'utils/attachment';
import { selectCategory } from 'redux/actions';

const image = 'https://picsum.photos/id/234/200/200'
const { Meta } = Card;

function GridViewCategories() {
    const { fetchedData: { categories }, theme: { locale } } = useSelector(state => state)
    const dispatch = useDispatch();


    return (
        <>
            <div className="mt-4">
                <Row gutter={24}>
                    {categories?.map(category => <Col xs={12} sm={8} md={6} lg={12} key={category?.id}>
                        <div className="grid-product-image-container">
                            <Link to={APP_PREFIX_PATH + '/categories/' + category?.id + '?nameEng=' + category?.nameEng + '&nameAr=' + category?.nameAr}>
                                <div onClick={() => { dispatch(selectCategory(category)) }}>
                                    <img className={'grid-product-image'} alt="example" src={category?.image?.id ? getAttachment(category?.image?.id) : '/img/productsFallback.svg'} />
                                    <div className='text-black my-2 font-16 font-bold'>
                                        {locale === 'en' ? category?.nameEng : category?.nameAr}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Col>)}
                </Row>
            </div>
        </>
    );
}

export default GridViewCategories;